const env = {
  apiEndPoint: 'https://api.gokatei.renraku.k-goal.net',
  axiosWithCredentials: false,
  company: {
    id: 'k-goal',
    name: '株式会社ゴール',
    brandName: '家庭教師のゴール',
    shortBrandName: 'ゴール',
    information: {
      tel: '087-806-0163',
      businessTime: '毎日 10 ~ 22 時'
    },
  },
  functions: ['report', 'contract'],
  report: {
    learningUnit: true,
    page: true,
  },
  familyQuestionnaires: {
    version: '20230301_001',
    inquiries: [
      { inquiry: '先生の遅刻や日時の変更はありますか', answers: ['問題ない', 'たまに', '毎回'] },
      { inquiry: '生徒さんに学習習慣はつきましたか？', answers: ['ついた', '少しずつ', 'テスト前だけ'] },
      { inquiry: 'テキストを利用していますか？', answers: ['しっかり利用している', '教科による', '利用していない'] },
    ],
  },
  confirmation: [
    {
      version: '20000101',
      items: [
        'ご契約されたお客様へ、数日内にお申込内容について確認のお電話が入ります。(その際は、本書面・ご契約書控え をお手元にご用意ください)',
        'テキストの配送は、①入会金・保証金のご入金 ②(ご一括払いの場合)テキスト代ご入金、(分割払いの場合)NCリンク(クレジット会社)承認 の双方を満たした時点で配送されます。',
        'マイプロフィールの提示を行い、会社名・担当者の名前をお伝えしましたか?',
        '「体験のご案内」についてsms等で事前案内がありましたか?(家庭教師とテキスト(学習ゼミ)のご案内・お申込み手続き・所用時間に関してのご説明)',
        '長時間にわたる無理な勧誘や、了承を得ない21時以降の勧誘はございませんでしたか?',
        'テキストあり・なしコースそれぞれの概要書面を受け取って、ご理解された上でどちらにするか決められましたか?',
        '必ず成績が上がるなどのオーバーな説明はございませんでしたか?',
        'テキスト(学習ゼミ)は、1学年単位で申し込みできることをご存じですか?また、最長契約時以外、次回更新時に事務手数料として5000円をいただく事はご存じですか?',
        'テキスト(学習ゼミ)の必要な数量・期間・回数はご自身で決められましたか?',
        'クーリングオフ制度(8日間 )を、自主的に6日間延長(14日間)していることをご存知ですか?期日内に先生の紹介が行われなかった場合に限り特別に適用させていただく場合がございます。)',
        '中途解約について、現在学年分は使用済みテキストの為、返品不可となります。未到来学年のテキストは未使用テキストの為、ご返品・キャンセルが可能という内容についてしっかりご説明がありましたか?',
        'お客様のご都合で口座振替ができなかった場合は、事務手数料として500円が加算され、送付されたお振込用紙にてお支払いいただきます。指導料もしくはテキスト代を累計2か月滞納している場合には、指導を停止及び家庭教師契約を解除することがございます。',
        'お引き落とし開始月と、終了月についてご理解いただけましたか?また、書類不備や本人確認連絡が繋がらない場合は、契約書に記載のお支払い月がずれる場合があります。'
      ]
    },
    {
      version: '20241110',
      items: [
        '数日以内にご契約書控えをPDFアップロードいたしますので、内容にお間違いがないか 必ずご確認ください。',
        'テキストの配送は、ご入金が確認できた時点で手続きを行います。*分割払いでお申し込みのお客様は、信販会社の承認が必要です。',
        'テキストあり・なしコースそれぞれの説明を受け、ご理解いただいた上でどちらにするか 決められましたか?*概要書面を保管いただくようお願いいたします。',
        'テキスト(学習ゼミ)は、1学年単位で申し込みできることをご存じですか?また、最長契約時 以外では、次回更新時に事務手数料として5,000円をいただくことをご存じですか?',
        'テキスト(学習ゼミ)の必要な数量、期間、回数について説明を受け、ご理解いただけていますか?',
        'お引き落とし開始月と終了月についてご理解いただけましたか?また、書類不備や本人確認が取れない場合、契約書に記載のお支払い月がずれることがございます。',
        '「体験のご案内」について、SMS等で事前案内がありましたか?(家庭教師およびテキスト(学習ゼミ)のご案内、お申込み手続き、所要時間に関してのご説明)',
        '体験授業時に、担当者がマイプロフィール等の提示を行い、会社名や担当者の名前をお伝えしましたか?',
        '長時間にわたる無理な勧誘や、了承を得ていない21時以降の勧誘はございませんでしたか?',
        '「必ず成績が上がる」といった過剰な説明はございませんでしたか?',
        'クーリングオフ制度(8日間)を、自主的に6日間延長(14日間)していることをご存じですか?*期日内に先生の紹介が行われなかった場合に限り、特別に延長を適用させていただく場合がございます。',
        '中途解約に関して、現学年分のテキストは使用済みとみなし返品不可となりますが、未到来の学 年分の未使用テキストは返品・キャンセルが可能であるという説明がありましたか?',
        'お客様のご都合で口座振替ができなかった場合、事務手数料として500円が加算され、送付さ れたお振込用紙にてお支払いいただきます。指導料もしくはテキスト代を累計2か月滞納して いる場合や、連絡が取れない場合には、指導の停止および家庭教師契約の解除を行うことが ございます。'
      ]
    },
  ]
};

export default env;
